<template>
    <div class="full-width" v-loading="loading">
        <div v-if="null != shopCompany">

            <div class="title-box" v-show="(pagePart === 'home' || pagePart === 'join') && (viewName !== 'product')">
                <h2 tkey="展會管理">{{titleText}}</h2>

                <div class="return-part" v-show="showReturnBtn !== null && showReturnBtn !== false">
                    <ReturnButton
                        @click="emitReturnFunc"
                        :label="i18n.tkey('lang_return')"
                        tkey="返回"
                    />
                </div>
            </div>

            <div v-if="pagePart === 'join'">
                <div v-if="viewName == 'list'">
                    <record15List
                        @clickView="clickViewBtn"
                        @clickEdit="clickEditBtn"
                        @clickProduct="clickProductBtn"
                    />
                </div>

                <div v-if="viewName == 'edit' || viewName == 'add'">
                    <addOrEditRecord15
                        :hallObj="hallObj"
                        :editObj="editObj"
                        :readonlyTag="readonlyTag"
                        @addComplete="addCallback"
                        @editComplete="returnFunc"
                    />
                </div>

                <div v-if="viewName == 'record14List'">
                    <record14List
                        @clickAdd="goAddView"
                    />
                </div>

                <div v-if="viewName == 'product'">
                    <JoinHallMaterialEditor
                        @clickReturnBtn="viewName = 'list'"
                    />
                </div>
            </div>

            <div v-if="pagePart === 'create'">
                <SponsorEditor
                    @clickReturnBtn="clickCallback"
                />
            </div>

            <div v-show="viewName == 'home'">
                <CompanyHallHome
                    @clickBtn="clickCallback"
                />
            </div>

        </div>
    </div>
</template>

<script setup>
    import record15List from "@/components/shopopee/hall/record15List"
    import addOrEditRecord15 from "@/components/shopopee/hall/addOrEditRecord15"
    import record14List from "@/components/shopopee/hall/record14List"
    import ReturnButton from "@/components/shopopee/common/returnButton.vue";
    import CompanyHallHome from "@/components/shopopee/home/CompanyHallHome.vue";
    import SponsorEditor from "@/components/shopopee/hall/sponsorEditor.vue";
    import JoinHallMaterialEditor from "@/components/shopopee/hall/joinHallMaterialEditor.vue";
    import {inject, onMounted, provide, ref, getCurrentInstance, onBeforeMount, computed, toRef} from "vue";
    import record15Api from "@/request/record15Api";
    import myUtil from "@/util/util";
    import {useUserinfo} from "@/stores/userinfo";
    import companyApi from "@/request/companyApi";

    const userInfoRef = toRef(useUserinfo())
    const i18n = inject("i18n")

    const props = defineProps(["showReturnBtn"])
    const emits = defineEmits(["clickReturnBtn"])

    // const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return null } })

    const { proxy } = getCurrentInstance()
    const shopCompany = ref(null)

    const viewName = ref("home")
    const pagePart = ref("home")

    const editObj = ref(null)
    const hallObj = ref(null)
    const readonlyTag = ref(null)
    const loading = ref(false)

    const authObj = ref(null)

    const titleText = computed(() => {
        let text = i18n.tkey("lang_hall_manager_1")

        if (pagePart.value === "join"){
            text = i18n.tkey("lang_join_exhibitions_manager")

            if (viewName.value === "product"){
                text = i18n.tkey("lang_exhibited_products")
            }
        }

        return text
    })

    function changeViewName(name){
        viewName.value = name
    }

    function goAddView(obj){
        if (myUtil.isEmpty(obj.addinfo4)){
            myUtil.alertWarning(i18n.tkey("lang_hall_already_finish"))
            return
        }

        if (null == shopCompany.value.additionalrecord11 || null == shopCompany.value.additionalrecord11.addinfo10){
            myUtil.confirmError(i18n.tkey("lang_join_hall_time_confirm_1"), () => {
                location.href = `${proxy.$ShopopeeUrl}apply_renew`
            })
            return;
        }

        const finishTime = new Date(obj.addinfo4).getTime()
        const expTime = new Date(shopCompany.value.additionalrecord11.addinfo10).getTime()

        if (expTime < finishTime){
            myUtil.confirmError(i18n.tkey("lang_join_hall_time_confirm_1"), () => {
                location.href = `${proxy.$ShopopeeUrl}apply_renew`
            })
            return;
        }

        hallObj.value = obj
        changeViewName("add")
    }

    function addCallback(){
        hallObj.value = null
        changeViewName("list")
    }

    function clickViewBtn(obj){
        obj.additionalrecord14.country = obj.country
        readonlyTag.value = true
        hallObj.value = obj.additionalrecord14
        editObj.value = obj

        changeViewName("add")
    }

    function clickEditBtn(obj){
        obj.additionalrecord14.country = obj.country
        hallObj.value = obj.additionalrecord14
        editObj.value = obj

        changeViewName("edit")
    }

    function returnFunc(){
        editObj.value = null
        hallObj.value = null
        readonlyTag.value = false

        changeViewName("list")
    }

    function emitReturnFunc(){
        if (null != authObj.value && null != authObj.value.hallNum && authObj.value.hallNum > 0 && viewName.value === "list"){
            viewName.value = "home"
            pagePart.value = "home"
        }else if(viewName.value === "list" || viewName.value === "home"){
            emits("clickReturnBtn")
        }else if(viewName.value === "product"){
            viewName.value = "home"
        }else if(pagePart.value === "create"){
            viewName.value = "home"
        }else{
            editObj.value = null
            hallObj.value = null
            readonlyTag.value = false

            changeViewName("list")
        }
    }

    function clickCallback(name){
        if (name == "add"){
            viewName.value = "add"
            pagePart.value = "create"
        }else if(name === "returnHome"){
            viewName.value = "home"
            pagePart.value = "home"
        }else{
            viewName.value = "list"
            pagePart.value = "join"
        }
    }

    function checkCompanyAuth(){
        let part = "list"
        let page = "join"

        if (null != shopCompany.value && null != shopCompany.value && null != shopCompany.value.additionalrecord11){
            var obj = shopCompany.value.additionalrecord11

            if (null != obj.addremark1){
                obj = JSON.parse(obj.addremark1)

                authObj.value = obj

                if (null != authObj.value.hallNum && authObj.value.hallNum > 0){
                    part = "home"
                    page = "home"
                }
            }
        }

        viewName.value = part
        pagePart.value = page

    }

    function clickProductBtn(){
        viewName.value = "product"
    }

    function getAuthObj(){
        return authObj.value
    }

    function getCompanyInfo(){
        loading.value = true

        const request = companyApi.getCompanyInfo
        const params = request.getParams()

        params.companycode = userInfoRef.value.selectCompanycode

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                shopCompany.value = res.detail
                checkCompanyAuth()
            }
        })

    }

    function getShopCompanyObj(){
        return shopCompany.value
    }

    provide('hallManagerFunc', {
        changeViewName,
        getAuthObj
    })

    provide('shopControlFunc', {
        getShopCompanyObj,
    })

    onBeforeMount(() => {
        // shopCompany.value = getShopCompanyObj()

        // if (null == shopCompany.value){
            getCompanyInfo()
        // }else{
        //     checkCompanyAuth()
        // }

    })

    onMounted(() => {


    })

</script>

<style scoped>
    .full-width {
        width: 100%;
        position: relative;
    }

    .return-part {
        position: absolute;
        left: 0;
        top: 5px;
    }

    .title-box {
        position: relative;
        text-align: center;
        margin-bottom: 30px;
    }
</style>